<template>
  <base-dialog
    :persistent="true"
    :is-open="isOpen"
    @close="onClose"
  >
    <template #dialog-title>
      Kollektenplan herunterladen
    </template>
    <template #dialog-text>
      <div class="d-flex jusitfy-space-between align-center">
        <text-field-date-picker
          label="Startdatum"
          :use-fall-back-date="true"
          @input="downloadCollectionPlanStart = $event"
        >
        </text-field-date-picker>

        <span class="mx-3">&mdash;</span>

        <text-field-date-picker
          label="Enddatum"
          @input="downloadCollectionPlanEnd = $event"
        >
        </text-field-date-picker>
      </div>
    </template>
    <template #dialog-actions>
      <div class="d-flex flex-column align-end">
        <div v-if="hasDownloadPermission">
          <v-btn
            color="primary"
            @click="downloadCollectionPlan"
          >
            Download
          </v-btn>
        </div>
        <div class="d-flex align-baseline">
          <span class="mr-2 caption">Vorlage herunterladen:</span>
          <v-btn
            x-small
            text
            color="primary"
            class="mr-1"
            @click="downloadCollectionPlanTemplate()"
          >
            leer
          </v-btn>
          <v-btn
            x-small
            text
            color="primary"
            class="mr-1"
            @click="downloadCollectionPlanTemplate(currentYear)"
          >
            {{ currentYear }}
          </v-btn>
          <v-btn
            x-small
            text
            color="primary"
            @click="downloadCollectionPlanTemplate(nextYear)"
          >
            {{ nextYear }}
          </v-btn>
        </div>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import moment from "moment/moment"
import TextFieldDatePicker from "@/components/UI/TextFieldDatePicker.vue"
import BaseDialog from "@/components/UI/BaseDialog.vue"
import { mapGetters } from "vuex"
import { READ_CPLAN } from "@/lib/permission-tools"
import { downloadBlob } from "@/lib/file-tools"

export default {
  name: 'CollectionPlanDownloadDialog',
  components: {
    BaseDialog,
    TextFieldDatePicker
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      downloadCollectionPlanStart: null,
      downloadCollectionPlanEnd: null
    }
  },
  computed: {
    ...mapGetters('organization', {
      organization: 'currentOrganization'
    }),
    ...mapGetters('user', ['isSuperuser', 'hasPermission']),
    currentYear () {
      return new Date().getFullYear()
    },
    nextYear () {
      return new Date().getFullYear() + 1
    },
    hasDownloadPermission () {
      return this.isSuperuser || this.hasPermission(this.organization.url, READ_CPLAN)
    }
  },
  methods: {
    async downloadCollectionPlanTemplate (year) {
      const url = new URL(`${this.organization.url}kollektenplan_template/`)
      if (year) {
        url.searchParams.set('with_dates', year)
      }

      const response = await this.$store.getters.restApi(url.toString(), {
        responseType: 'blob'
      })
      const contentType = response.headers['content-type']
      const filename = `${this.organization.id}-${this.organization.name}-kollektenplan.xlsx`
      downloadBlob(response.data, filename, contentType)
      this.isCollectionPlanDownloadDialogOpen = false
    },
    async downloadCollectionPlan () {
      const url = new URL(`${this.organization.url}export_collection_plans/`)

      const start = this.downloadCollectionPlanStart ? moment(this.downloadCollectionPlanStart) : moment()
      if (this.downloadCollectionPlanStart) {
        url.searchParams.set('start__gte', start.format())
      }

      const end = this.downloadCollectionPlanEnd ? moment(this.downloadCollectionPlanEnd) : moment()
      if (this.downloadCollectionPlanEnd) {
        url.searchParams.set('start__lt', end.format())
      }

      const response = await this.$store.getters.restApi(url.toString(), {
        responseType: 'blob',
      })

      const timestampStart = start.format('YYYY-MM-DD')
      const timestampEnd = end.format('YYYY-MM-DD')
      const filename = `${this.organization.id}_${this.organization.name}-${timestampStart}_${timestampEnd} Export Kollektenplan.xlsx`

      const contentType = response.headers['content-type']
      downloadBlob(response.data, filename, contentType)
      this.isCollectionPlanDownloadDialogOpen = false
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>
